import React, { useState } from "react";
import { Flex, Box, Image, Text } from "@chakra-ui/react";
import PerformanceIcon from "../Images/PerformanceCardIcon.svg";
import { a } from "./appColors";

const PerformanceCardDashboard = () => {

  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      width="245px"
      height="114px" 
      display="flex"
      flexDirection="column"
      justifyContent="space-between" 
      alignItems="center"
      gap="4px"
      flexShrink="0"
      
    >
      <Box
        display="flex"
        padding="14px 40px 16px 12px"
        alignItems="center"
        justifyContent="center" 
        borderRadius="20px"
        width="100%"
        onMouseEnter = {() => setIsHovered(true)}
        onMouseLeave= {() => setIsHovered(false)}
        background = {isHovered ? "transparent": "transparent"}
        border = {isHovered ? `1px solid ${a.border}`: `1px solid ${a.border}` }

      >
        <Image
          src={PerformanceIcon}
          alt="Performance Icon"
          marginRight="12px"
          boxSize="40px"
        />
        <Text
          
          fontSize="18px"
          fontWeight="400"
          lineHeight="normal"
          marginRight="8px"
          color={a.text}
        >
          0
        </Text>
        <Text
          fontSize="14px"
          fontWeight="400"
          lineHeight="normal"
          color={a.text}
        >
          Papers solved
        </Text>
      </Box>

      {/* Overall performance box */}
      <Box
        display="flex"
        flexDirection="column"
        gap="8px"
        alignItems="stretch" // Ensure the text and bar are aligned
        width="100%" // Take up full width for balance
        padding="0 10px" // Add padding for balance
      >
        <Flex justifyContent="space-between" alignItems="center" width="100%">
          <Text
            color={a.text}
            fontSize="14px"
            fontWeight="300"
            lineHeight="normal"
          >
            Overall performance
          </Text>
          <Text
            color={a.text}
            fontSize="14px"
            fontWeight="300"
            lineHeight="normal"
          >
            0%
          </Text>
        </Flex>

        {/* Progress bar */}
        <Box
          width="100%"
          height="10px" // Slightly increased height
          backgroundColor={a.border}
          borderRadius="5px"
          overflow="hidden"
          position="relative"
        >
          <Box
            width="0%" // Adjust the percentage width as per progress
            height="100%"
            backgroundColor={a.accent}
            borderRadius="5px"
            position="absolute"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PerformanceCardDashboard;
